import React from 'react'
import styled from 'styled-components'
import Layout from '../components/layout/Layout'
import { SectionWrapper } from '../components/common/wrappers/Wrappers'
import { SectionText } from '../components/common/typography/Typography'
import { breakpoint, color, transition } from '../configs/utilities'

const Cookie_Statement = () => {
  return (
    <Layout pageName="cookie-statement">
      <SectionWrapper>
        <Wrapper>
          <Title>Cookie Policy for aleksandragocanin.com</Title>

          <SectionText>This is the Cookie Policy for aleksandragocanin.com, accessible from www.aleksandragocanin.com</SectionText>

          <SectionText>
            <strong>What Are Cookies</strong>
          </SectionText>

          <SectionText>
            As is common practice with almost all professional websites this site uses cookies, which are tiny files
            that are downloaded to your computer, to improve your experience. This page describes what information they
            gather, how we use it and why we sometimes need to store these cookies. We will also share how you can
            prevent these cookies from being stored however this may downgrade or 'break' certain elements of the sites
            functionality.
          </SectionText>

          <SectionText>
            <strong>How We Use Cookies</strong>
          </SectionText>

          <SectionText>
            We use cookies for a variety of reasons detailed below. Unfortunately in most cases there are no industry
            standard options for disabling cookies without completely disabling the functionality and features they add
            to this site. It is recommended that you leave on all cookies if you are not sure whether you need them or
            not in case they are used to provide a service that you use.
          </SectionText>

          <SectionText>
            <strong>Disabling Cookies</strong>
          </SectionText>

          <SectionText>
            You can prevent the setting of cookies by adjusting the settings on your browser (see your browser Help for
            how to do this). Be aware that disabling cookies will affect the functionality of this and many other
            websites that you visit. Disabling cookies will usually result in also disabling certain functionality and
            features of the this site. Therefore it is recommended that you do not disable cookies. This Cookies Policy
            was created with the help of the
            <a
              href="https://www.cookiepolicygenerator.com/cookie-policy-generator/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Cookies Policy Generator
            </a>
            .
          </SectionText>
          <SectionText>
            <strong>The Cookies We Set</strong>
          </SectionText>

          <ul>
            <li>
              <SectionText>Forms related cookies</SectionText>
              <SectionText>
                When you submit data to through a form such as those found on contact pages or comment forms cookies may
                be set to remember your user details for future correspondence.
              </SectionText>
            </li>

            <li>
              <SectionText>Site preferences cookies</SectionText>
              <SectionText>
                In order to provide you with a great experience on this site we provide the functionality to set your
                preferences for how this site runs when you use it. In order to remember your preferences we need to set
                cookies so that this information can be called whenever you interact with a page is affected by your
                preferences.
              </SectionText>
            </li>
          </ul>

          <SectionText>
            <strong>Third Party Cookies</strong>
          </SectionText>

          <SectionText>
            In some special cases we also use cookies provided by trusted third parties. The following section details
            which third party cookies you might encounter through this site.
          </SectionText>

          <ul>
            <li>
              <SectionText>
                This site uses Google Analytics which is one of the most widespread and trusted analytics solution on
                the web for helping us to understand how you use the site and ways that we can improve your experience.
                These cookies may track things such as how long you spend on the site and the pages that you visit so we
                can continue to produce engaging content.
              </SectionText>
              <SectionText>
                For more information on Google Analytics cookies, see the official Google Analytics page.
              </SectionText>
            </li>

            <li>
              <SectionText>
                From time to time we test new features and make subtle changes to the way that the site is delivered.
                When we are still testing new features these cookies may be used to ensure that you receive a consistent
                experience whilst on the site whilst ensuring we understand which optimizations our users appreciate the
                most.
              </SectionText>
            </li>

            <li>
              <SectionText>
                We also use social media buttons and/or plugins on this site that allow you to connect with your social
                network in various ways. For these to work the following social media sites including; List the social
                networks whose features you have integrated with your site?:12, will set cookies through our site which
                may be used to enhance your profile on their site or contribute to the data they hold for various
                purposes outlined in their respective privacy policies.
              </SectionText>
            </li>
          </ul>

          <SectionText>
            <strong>More Information</strong>
          </SectionText>

          <SectionText>
            Hopefully that has clarified things for you and as was previously mentioned if there is something that you
            aren't sure whether you need or not it's usually safer to leave cookies enabled in case it does interact
            with one of the features you use on our site.
          </SectionText>

          <SectionText>
            For more general information on cookies, please read
            <a
              href="https://www.cookiepolicygenerator.com/sample-cookies-policy/"
              target="_blank"
              rel="noopener noreferrer"
            >
              the Cookies Policy article
            </a>
            .
          </SectionText>

          <SectionText>
            However if you are still looking for more information then you can contact us through one of our preferred
            contact methods:
          </SectionText>
          <ul>
            Email:
            <li>
              <a href="mailto:ivangochanin@gmail.com">ivangochanin@gmail.com</a>
            </li>
            <li>
              <a href="mailto:arterija@gmail.com">arterija@gmail.com</a>
            </li>
          </ul>
        </Wrapper>
      </SectionWrapper>
    </Layout>
  )
}

export default Cookie_Statement

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  row-gap: 20px;


  a {
    color: ${color.blue};
    transition: ${transition.default};
    padding-left: 5px;
    &:hover {
      opacity: 0.7;
    }
  }

  ul {
    padding-left: 50px;
    li {
      margin-top: 10px;
    }
  }
`

const Title = styled.h1`
  font-weight: 400;
  font-size: 27px;
  line-height: 48px;
  margin-bottom: 20px;
  text-align: center;

  @media screen and (max-width: ${breakpoint.xsm}) {
    font-size: 8vw;
    line-height: 10vw;
  }

  @media screen and (min-width: ${breakpoint.md}) {
    font-size: 38px;
    margin-bottom: 40px;
  }

  @media screen and (min-width: ${breakpoint.xl}) {
    font-size: 46px;
    margin-bottom: 50px;
  }
`
